import { render, staticRenderFns } from "./Overviews.vue?vue&type=template&id=137189dc&scoped=true"
import script from "./Overviews.vue?vue&type=script&lang=js"
export * from "./Overviews.vue?vue&type=script&lang=js"
import style0 from "./Overviews.vue?vue&type=style&index=0&id=137189dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137189dc",
  null
  
)

export default component.exports